import { useTranslation } from 'react-i18next';
import { useApiMutation } from '../../../hooks/useApiMutation';
import { deleteTemplate } from '../api/logbookApi';
import { UseApiMutationOptions } from '../types/loogBookTypes';

type MutationResponse = { message: string };
type MutationVariables = string;

/**
 * [Responsibility: API Mutation]
 * A dedicated hook for deleting a logbook template via the API.
 * @param options - Configuration options for the mutation.
 */
export const useDeleteLogbookTemplate = (
  options?: UseApiMutationOptions<MutationResponse, Error, MutationVariables>,
  invalidateQueryKey?: any
) => {
  const { t } = useTranslation();
  return useApiMutation<MutationResponse, Error, MutationVariables>(deleteTemplate, {
    successMessage: t('logbook.templates.deleteSuccess', 'Logbook template deleted successfully'),
    errorMessage: t('logbook.templates.deleteFailed', 'Failed to delete logbook template'),
    invalidateQueryKeys: [invalidateQueryKey],
    ...options,
  });
};
